/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EvmAddressSummaryInfo } from './EvmAddressSummaryInfo';

export type EvmInternalTraceInfo = {
    TTADDR: string;
    ADDRSFROMINFO: EvmAddressSummaryInfo;
    ADDRSTOINFO: EvmAddressSummaryInfo;
    VAL: string;
    GL: string;
    STATTP: EvmInternalTraceInfo.STATTP;
};

export namespace EvmInternalTraceInfo {

    export enum STATTP {
        SUCCESS = 'SUCCESS',
        FAILURE = 'FAILURE',
        PENDING = 'PENDING',
        FAILED = 'FAILED',
        OUT_COMING = 'OUT_COMING',
        IN_COMING = 'IN_COMING',
        ALL = 'ALL',
    }


}

